import { AuMcpPath } from './backend-paths';

/** `path` on the platform served at `platformBaseUrl` (trailing slashes ignored). */
export const platformUrl = (platformBaseUrl: string, path: string): string => {
  let end = platformBaseUrl.length;
  while (end > 0 && platformBaseUrl[end - 1] === '/') {
    end--;
  }
  return `${platformBaseUrl.slice(0, end)}${path}`;
};

/**
 * Auth0 API identifier (access token `aud`) for the platform API served at
 * `platformBaseUrl`. Platform-ui requests tokens for it and the backend only
 * accepts bearer tokens issued for it.
 */
export const platformApiAudience = (platformBaseUrl: string): string =>
  platformUrl(platformBaseUrl, '/api');

/**
 * Auth0 API identifier (access token `aud`) for the MCP server. Also its
 * RFC 9728 resource identifier. Distinct from the platform API audience so
 * tokens for one are never accepted by the other.
 */
export const platformMcpAudience = (platformBaseUrl: string): string =>
  platformUrl(platformBaseUrl, AuMcpPath);
